import { sep } from 'path';

const RELATIVE_START = `node_modules${sep}`;

// Pass in the module's `require` object since it's module-specific.
export default moduleRequire => path => {
  // package.json removed because babel-runtime is resolved as
  // "babel-runtime/package"
  const absolutePath = moduleRequire.resolve(path).replace(/[\\/]package\.json$/, '');

  const relativeStartIndex = absolutePath.indexOf(RELATIVE_START);

  if (relativeStartIndex === -1) {
    return absolutePath;
  }

  return absolutePath.substring(relativeStartIndex + RELATIVE_START.length);
};
